const MAX_DATA_LIMIT = 10;

export {
  MAX_DATA_LIMIT
}
